module.exports = __webpack_public_path__ + "img/pin.2c600c13.svg";